import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class InfoBarWithStatusService {

  constructor(
    private _snackBar: MatSnackBar
  ) { }

  public showSnackbar(message: string, panelClass: string[] = [], duration: number = 4000): void {
    this._snackBar.open(message, '', {
      duration: duration,
      panelClass: panelClass
    });
  }
}
